import React from 'react';

import { Button, EmptyState } from '@ergeon/core-components';
import { ExclamationTriangleIcon } from '@ergeon/icons/hero/outline';

const NodeError = ({ onRetry }: { onRetry: () => void }) => (
  <div className="py-12" role="alert">
    <EmptyState
      actions={<Button flavor="primary" onClick={onRetry}>Try again</Button>}
      description="We could not load this page. Check your connection and try again."
      icon={<ExclamationTriangleIcon />}
      title="This page did not load" />
  </div>
);

export default NodeError;
